<template>
  <v-sheet v-if="smAndUp" class="button-group">
    <span class="mx-1">{{ session.time }}</span>
    <template v-if="!isLobby">
      <div class="divider"></div>
      <v-btn variant="flat" size="small" :rounded="4" id="resetBtn" icon="msf:fit_screen" @click="resetHandler">
      </v-btn>
      <v-btn variant="flat" size="small" :rounded="4" id="zoomOutBtn" icon="zoom_out" @click="zoomOut"> </v-btn>
      <v-btn variant="flat" size="small" :rounded="4" id="zoomInBtn" icon="zoom_in" @click="zoomIn"> </v-btn>
      <v-btn
        v-if="user.isAssistant"
        variant="flat"
        size="small"
        :rounded="4"
        icon="drag_pan"
        active-color="primary"
        :active="board.task === 'panning'"
        id="panBtn"
        @click="togglePan"
      >
      </v-btn>
      <v-btn
        v-if="fullscreenEnabled"
        :data-wml-speech-command="$t('meeting.commands.fullscreen')"
        @click="toggle"
        variant="flat"
        size="small"
        :rounded="4"
        :icon="`${isFullscreen ? 'close_fullscreen' : 'pan_zoom'}`"
        id="fullscreenBtn"
      >
      </v-btn>
    </template>
  </v-sheet>
</template>

<script setup>
import {onMounted, onUnmounted} from 'vue'
import {useBoardStore, useSessionStore, useTransformStore, useUserStore} from '@/stores'
import {useMeetingStore} from '@/stores'
import {useFullscreen} from '@vueuse/core'
import {useDisplay} from 'vuetify'
import {storeToRefs} from 'pinia'
const user = useUserStore()
const meetingStore = useMeetingStore()
const {isLobby} = storeToRefs(meetingStore)
const board = useBoardStore()
const {smAndUp} = useDisplay()
const transform = useTransformStore()
const session = useSessionStore()
const {isFullscreen, toggle} = useFullscreen()
const {fullscreenEnabled} = document

const step = 0.2

// ELEMENT HANDLERS

const zoomIn = () => {
  transform.updateZoom(transform.zoom + step * 1)
}
const zoomOut = () => {
  transform.updateZoom(transform.zoom - step * 1)
}
const togglePan = () => {
  if (board.task === 'panning') {
    board.setTask(null)
  } else {
    board.setTask('panning')
  }
}
function resetHandler() {
  transform.resetTransform()
}

// DOCUMENT HANDLERS

const documentWheelHandler = event => {
  if (event.target.tagName.toLowerCase() === 'canvas') {
    const sign = Math.sign(-event.deltaY)
    transform.updateZoom(transform.zoom + step * sign)
  }
}

function setDocumentEventHandlers() {
  document.addEventListener('wheel', documentWheelHandler)
}

function removeDocumentEventHandlers() {
  document.removeEventListener('wheel', documentWheelHandler)
}

onMounted(() => {
  setDocumentEventHandlers()
})

onUnmounted(() => {
  removeDocumentEventHandlers()
})
</script>

<style lang="scss" scoped>
@import '@/scss/button-group';
</style>
